<template>
  <div class="table-container">
    <div class="h1">{{t('enum.text_15')}}</div>
    <div class="sub-title">{{ t('salesSettlement.content.text_4') }}</div>
    <div class="sr-container__content sr-container__content--row">
      <el-form :model="formReq.fields" inline :label-width="localCN?'100px':'160px'" label-position="left">
        <el-form-item :label="formReq.schema.monthId.label">
          <el-date-picker
            v-model="formReq.fields.monthId"
            type="monthrange"
            clearable="false"
            :start-placeholder="t('salesSettlement.placeholder.startMonth')"
            :end-placeholder="t('salesSettlement.placeholder.endMonth')"
            value-format="YYYY-MM"
            :placeholder="formReq.schema.monthId.placeholder" />
        </el-form-item>
        <el-form-item :label="formReq.schema.inviteCode.label">
          <el-input v-model="formReq.fields.inviteCode" :placeholder="formReq.schema.inviteCode.placeholder" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">{{t('salesSettlement.content.text_1')}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadList">{{t('salesSettlement.content.text_3')}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table row-class-name="row-con" :data="tbl.data.list" v-loading="tbl.data.loading">
      <sr-tbl-column :columns="tbl.columns">
      </sr-tbl-column>
      <template #empty>
        <div class="empty-wrap">
          <img :src="emptyImg" alt="">
          {{t('salesSettlement.content.text_2')}}
        </div>
      </template>
    </el-table>
    <sr-tbl-pagination
        v-model:current-page="tbl.pagination.currentPage"
        v-model:page-size="tbl.pagination.pageSize"
        :total="tbl.pagination.total"
        @fetchData="fetchData">
    </sr-tbl-pagination>
  </div>
</template>
<script>
import tableComp from '@/compositions/modules/table'
import SrTblColumn from '@/components/SrTblColumn'
import { components } from '@libs/ui'
import { ref, reactive } from 'vue'
import { fetchSalesSettlement } from "@/api/modules/list"
import formComp from "@/compositions/modules/form"
import { SalesSettlementReq } from "@/domain/modules/list"
import { SalesSettlementColumns } from "@/domain/modules/settlement"
import { useI18n } from "@/plugins/i18n"
import { downloadFile } from "@/utils/download"
import { list } from '@/api/url'
import { useStore } from "vuex"
export default {
  components: { SrTblColumn, SrTblPagination: components.SrTblPagination },
  setup() {
    const store = useStore()
    const { t } = useI18n()
    const { tbl, fetchData, formReq } = initTable()
    const handleSearch = () => fetchData()
    const downloadList = async () => {
      formReq.fields.inviteCode = (formReq.fields.inviteCode || "").trim()
      await downloadFile(list.salesSettlementExport, formReq.fields)
    }
    const emptyImg = ref(require("@/assets/img/dashboard/empty.png"))
    return {
      tbl,
      fetchData,
      emptyImg,
      formReq,
      t,
      handleSearch,
      downloadList,
      store
    }
  }
}

const initTable = () => {
  const store = useStore()
  const { createTable } = tableComp()
  const { formReq } = initForm()
  const tbl = createTable({ columns: SalesSettlementColumns })

  const fetchData = async () => {
    const params = {
      userId: store.state.user.userId,
      pageInfo: {
        current: tbl.pagination.currentPage,
        size: tbl.pagination.pageSize,
      },
      monthId: formReq.fields.monthId || "",
      inviteCode: (formReq.fields.inviteCode || "").trim(),
    }
    tbl.data.loading = true
    tbl.data.list = []
    try {
      const res = await fetchSalesSettlement(params)
      tbl.data.list = res.list || []
      tbl.pagination.total = res.pageInfo.total || 0
    } finally {
      tbl.data.loading = false
    }
  }
  fetchData()
  return { tbl, fetchData, formReq }
}

const initForm = () => {
  const { createForm } = formComp()
  const formReq = reactive({ ...createForm({ items: SalesSettlementReq }) })
  return { formReq }
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  .table-container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 4px;
    padding: 30px 20px;

    .sub-title {
      margin: 0 0 25px;
      color: #909399;
      font-size: 14px;
    }

    .empty-wrap {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 160px auto;
      box-sizing: border-box;

      & > img {
        width: 190px;
        height: auto;
        display: block;
        margin-bottom: 38px;
      }
    }

    /deep/ .el-form .el-input__inner {
      width: 220px;
    }

    /deep/ .el-date-editor {
      width: 100%;
    }

    :deep(.row-con) {
      height: 57px;
    }

    :deep(.el-table .cell) {
      div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
</style>
